<div class="sales-communication-settings">
  <div class="sales-communication-settings-title" i18n>Sales comm settings</div>
  <div class="sales-communication-settings-line" i18n>
    Argo identifier (order or contract): <span class="sales-communication-settings-line-info">{{ argoIdentifier }}</span>
  </div>
  <div class="sales-communication-settings-line" i18n>
    Client name: <span class="sales-communication-settings-line-info">{{ clientName }}</span>
  </div>
</div>
